export function normalizeChartData(data) {
    return data
      .map(item => ({
        date: new Date(item.fields["Created At"]),
        total: item.fields["Total Score"],
        policy: item.fields["Policy Score"],
        people: item.fields["People Score"],
        technology: item.fields["Technology Score"],
        person: item.fields["Submitted By"],
      }))
      .sort((a, b) => a.date - b.date);
  }